var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},[_vm._l((_vm.tags),function(tag){return [_c('div',{key:tag.id},[_c('span',{staticClass:"tag_name",on:{"click":function($event){return _vm.$emit('clicked', tag.name)}}},[_vm._v("#"+_vm._s(tag.name))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }